<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        v-if="customer"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('dialogs.customer.requestCancellation.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <p>
                    {{ $t('dialogs.customer.requestCancellation.text') }}
                    <strong>{{ customer.trade_name }} </strong>?
                </p>

                <v-text-field
                    :label="
                        $t(
                            'resources.cancellationRequisition.attributes.reason',
                        )
                    "
                    v-model="reason"
                    :counter="255"
                    @input="$v.reason.$touch()"
                    @blur="$v.reason.$touch()"
                    :error-messages="reasonErrors"
                >
                </v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click.native="cancel"
                >
                    {{ $t('dialogs.customer.requestCancellation.decline') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click.native="agree"
                >
                    {{ $t('dialogs.customer.requestCancellation.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    data: () => ({
        customer: null,
        dialog: false,
        reason: undefined,
        resolve: undefined,
        reject: undefined,
    }),

    validations() {
        return {
            reason: { required },
        }
    },

    mixins: [validationMixin],

    computed: {
        reasonErrors() {
            const errors = []
            if (!this.$v.reason.$dirty) return errors
            !this.$v.reason.required &&
                errors.push(
                    this.$t('forms.errors.required', {
                        label: this.$t(
                            'resources.cancellationRequisition.attributes.reason',
                        ),
                    }),
                )
            return errors
        },
    },

    methods: {
        open(customer) {
            this.reason = undefined
            this.dialog = true
            this.customer = customer

            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        agree() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('forms.messages.validationError'),
                )

                return
            }

            this.customer.requestCancellation(this.reason).then(res => {
                this.dialog = false

                if (!res) {
                    this.resolve(false)
                    return
                }

                this.$bus.$emit(
                    'notify',
                    'success',
                    this.$t('dialogs.customer.requestCancellation.success'),
                )

                this.resolve(true)
            })
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
        },
    },
}
</script>
